import { useEffect } from 'react';
import { helpItems, indexStored, loadRules, onPlayer, playTts, stopTts, ttsFind, ttsReady, TTS_LANGS } from '../lib/helpAudio';

const SEL = 'p, small, span.muted, div.small-hint, div.hint, [class*="hint"], [class*="-note"]';
const ICON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4.7a.7.7 0 0 0-1.2-.5L6.4 7.6A1.4 1.4 0 0 1 5.4 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.4a1.4 1.4 0 0 1 1 .4l3.4 3.4a.7.7 0 0 0 1.2-.5z"/><path d="M16 9a5 5 0 0 1 0 6"/><path d="M19.4 18.4a9 9 0 0 0 0-12.8"/></svg>';
const norm = (s) => s.replace(/\s+/g, ' ').trim();

// field hints: adds a read-aloud button to every fixed hint text on screen that already has a stored recording
export default function HintSpeaker({ t, lang }) {
  useEffect(() => {
    if (!TTS_LANGS.includes(lang)) return undefined;
    loadRules();
    indexStored(lang);
    let alive = true, map = null, tm = null;
    const btns = new Set();
    const build = async () => {
      const ok = await ttsReady(lang), m = new Map();
      await Promise.all(helpItems(lang).filter((x) => x.id.startsWith('hint:')).map(async (x) => { const h = await ttsFind(lang, x.text); if (h && ok.has(h) && !m.has(norm(x.text))) m.set(norm(x.text), { id: x.id, h }); }));
      return m;
    };
    const mk = (el, { id, h }) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'speak-btn hint-speak'; b.dataset.testid = `speak-${id.replace(/[:~]/g, '-')}`; b.dataset.tts = id;
      b.title = t.ttsPlay; b.setAttribute('aria-label', t.ttsPlay); b.innerHTML = ICON;
      b.onclick = (e) => { e.preventDefault(); e.stopPropagation(); if (b.classList.contains('on')) stopTts(); else playTts(id, h); };
      el.appendChild(b); el.dataset.ttsDone = '1'; btns.add(b);
    };
    const scan = () => {
      if (!map?.size) return;
      document.querySelectorAll(SEL).forEach((el) => {
        if (el.dataset.ttsDone || el.closest('.tour-layer, .manual-dialog, button, label > input') || el.querySelector(':scope > *:not(br):not(b):not(em):not(strong)')) return;
        const hit = map.get(norm(el.textContent || ''));
        if (hit) mk(el, hit);
      });
    };
    const kick = () => { clearTimeout(tm); tm = setTimeout(scan, 300); };
    const obs = new MutationObserver(kick);
    build().then((m) => { if (!alive) return; map = m; scan(); obs.observe(document.body, { childList: true, subtree: true }); });
    const off = onPlayer((cur) => btns.forEach((b) => (b.isConnected ? b.classList.toggle('on', b.dataset.tts === cur) : btns.delete(b))));
    return () => {
      alive = false; clearTimeout(tm); obs.disconnect(); off();
      btns.forEach((b) => { delete b.parentElement?.dataset.ttsDone; b.remove(); });
    };
  }, [lang, t]);
  return null;
}
